"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMinutesSince = exports.areOnSameDay = exports.addSeconds = exports.addDays = exports.getStartOfDay = exports.getStartOfToday = void 0;
function getStartOfToday() {
    return getStartOfDay(new Date());
}
exports.getStartOfToday = getStartOfToday;
function getStartOfDay(date) {
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();
    return new Date(year, month, day);
}
exports.getStartOfDay = getStartOfDay;
function addDays(date, days) {
    const copy = new Date(date);
    copy.setDate(date.getDate() + days);
    return copy;
}
exports.addDays = addDays;
function addSeconds(date, seconds) {
    const copy = new Date(date);
    copy.setSeconds(date.getSeconds() + seconds);
    return copy;
}
exports.addSeconds = addSeconds;
function areOnSameDay(left, right) {
    const dayLeft = left.getDate();
    const dayRight = right.getDate();
    if (dayLeft !== dayRight)
        return false;
    const monthLeft = left.getMonth();
    const monthRight = right.getMonth();
    if (monthLeft !== monthRight)
        return false;
    const yearLeft = left.getFullYear();
    const yearRight = right.getFullYear();
    return yearLeft === yearRight;
}
exports.areOnSameDay = areOnSameDay;
function getMinutesSince(date) {
    const now = new Date();
    const diffMillis = now.getTime() - date.getTime();
    return (diffMillis / 1000) / 60;
}
exports.getMinutesSince = getMinutesSince;
